import PropTypes from 'prop-types';

// @mui
import { Grid, Paper } from '@mui/material';

import { useAuth } from 'src/hooks/useAuth';

import Loader from 'src/components/loaders/Loader';
import EmptyGrid from 'src/components/emptyGrid/emptyGrid';

import DepartmentCard from './DepartmentCard';

DepartmentsList.propTypes = {
  departments: PropTypes.array.isRequired,
  handleDelete: PropTypes.func,
  itemsPerPage: PropTypes.number,
  page: PropTypes.number,
  editDepartment: PropTypes.func,
  filterName: PropTypes.string,
  isNotFound: PropTypes.bool,
  searchIsNotFound: PropTypes.bool,
  isLoading: PropTypes.bool,
  getDeptTicketCount: PropTypes.func,
  getDeptUserCount: PropTypes.func,
  onManageMembers: PropTypes.func,
};

export default function DepartmentsList({
  getDeptTicketCount,
  getDeptUserCount,
  departments,
  handleDelete,
  itemsPerPage,
  page,
  filterName,
  isNotFound,
  searchIsNotFound,
  isLoading,
  editDepartment,
  onManageMembers,
  ...other
}) {
  const { permissions } = useAuth();

  const canUpdate = permissions?.includes('DEPARTMENT:UPDATE');
  const canDelete = permissions?.includes('DEPARTMENT:DELETE');
  const showOptions = canUpdate || canDelete;

  return (
    <Grid container spacing={3} {...other}>
      {!isLoading ? (
        <>
          {departments
            .slice(page * itemsPerPage, page * itemsPerPage + itemsPerPage)
            .map((department) => (
              <Grid key={department.id} item xs={6} sm={4} md={3}>
                <DepartmentCard
                  department={department}
                  handleDelete={handleDelete}
                  editDepartment={editDepartment}
                  getDeptTicketCount={getDeptTicketCount}
                  getDeptUserCount={getDeptUserCount}
                  onManageMembers={onManageMembers}
                  canUpdate={canUpdate}
                  canDelete={canDelete}
                  showOptions={showOptions}
                />
              </Grid>
            ))}
          {isNotFound && (
            <EmptyGrid searchIsNotFound={searchIsNotFound} filterName={filterName} />
          )}
        </>
      ) : (
        <Paper
          sx={{
            width: '100%',
            py: 5,
            my: 5,
            textAlign: 'center',
          }}
        >
          <Loader size={175} />
        </Paper>
      )}
    </Grid>
  );
}
